import { render, staticRenderFns } from "./air-tier.vue?vue&type=template&id=426261d7&"
import script from "./air-tier.vue?vue&type=script&lang=js&"
export * from "./air-tier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports